// ─────────────────────────────────────────────
//  CaseDragStatus — the two things a committed drag has to say out loud.
//
//  1. A polite LIVE REGION. The gesture is silent to a screen reader by
//     definition: the drag handle's `aria-valuetext` tracks the candidate, but
//     nothing announces what was actually written. This does.
//  2. The UNDO bar. The write has already happened — the board must be correct —
//     so this is not a confirmation, it is a way back. It is also what holds the
//     phone notification: while this bar is on screen nobody has been messaged.
//
//  ⚠️ ONE LIVE REGION, AND IT IS NOT THE TOAST'S. `ToastContext` already renders
//  an `aria-live="polite"` container; the undo bar deliberately is NOT one, so a
//  committed drag is announced once rather than twice. (This repo has been bitten
//  by a second live region before — see the shared `Alert` component.)
// ─────────────────────────────────────────────
import React from "react";
import tokens from "../../theme/tokens";

const { color, font, radius, shadow } = tokens;

export default function CaseDragStatus({ announcement, pending, onUndo }) {
  return (
    <>
      <div role="status" aria-live="polite" style={S.srOnly}>
        {announcement}
      </div>
      {pending && (
        <div style={S.bar}>
          <span style={S.text}>
            {pending.roomName} moved. Everyone on the row is told in a few seconds.
          </span>
          <button type="button" style={S.undo} onClick={onUndo}>
            Undo
          </button>
        </div>
      )}
    </>
  );
}

const S = {
  srOnly: {
    position: "absolute",
    width: 1,
    height: 1,
    padding: 0,
    margin: -1,
    overflow: "hidden",
    clip: "rect(0 0 0 0)",
    whiteSpace: "nowrap",
    border: 0,
  },
  bar: {
    position: "fixed",
    // Above the chart, clear of the toast stack (which pins top-right).
    left: "50%",
    bottom: 24,
    transform: "translateX(-50%)",
    zIndex: 1400,
    display: "flex",
    alignItems: "center",
    gap: 12,
    maxWidth: "min(560px, calc(100vw - 32px))",
    padding: "10px 12px",
    background: color.text.primary,
    color: "#fff",
    borderRadius: radius.md,
    boxShadow: shadow.lg,
    fontSize: font.size.body,
  },
  text: { minWidth: 0 },
  undo: {
    flexShrink: 0,
    // 44px of target on the one control that takes a mistake back.
    minHeight: 44,
    minWidth: 88,
    padding: "0 16px",
    fontFamily: "inherit",
    fontSize: font.size.body,
    fontWeight: font.weight.bold,
    color: color.text.primary,
    background: "#fff",
    border: "none",
    borderRadius: radius.sm,
    cursor: "pointer",
  },
};
